(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('consignmentPlanBuild', {
        templateUrl: 'views/components/views/consignmentPlanBuild/consignmentPlanBuild.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'consignmentPlanBuildService', 'consignmentPlanService', 'colliDispatchService', 'transportAreasService', 'rememberService', function ($stateParams, stateService, utilityService, translateService, modalService, consignmentPlanBuildService, consignmentPlanService, colliDispatchService, transportAreasService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let custactNo = $stateParams.custact_no;
            let spinStopTimer = null;

            let variableNames = {
                date_fom: '',
                date_tom: '',
                dateselector_index: ''
            };

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_remove_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                deliveryMethodButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clearDeliveryMethod() }
                ],
                transportAreaButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clearTransportArea() }
                ],
                filterValueButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filtervalue = '' }
                ],
                bgConsignmentPlanBuildFunction: {
                    selected: 'ADD',
                    buttons: [
                        { id: 'ADD', label: 'gb_consignmentplanbuild_function_add', color: 'primary', onClick: () => vm.model.bgConsignmentPlanBuildFunction.selected = 'ADD' },
                        { id: 'REMOVE', label: 'gb_consignmentplanbuild_function_remove', color: 'primary', onClick: () => vm.model.bgConsignmentPlanBuildFunction.selected = 'REMOVE' },
                        { id: 'SPLIT', label: 'gb_consignmentplanbuild_function_split', color: 'primary', onClick: () => vm.model.bgConsignmentPlanBuildFunction.selected = 'SPLIT' }
                    ]
                },
                bgConsignmentPlanBuildAdd: {
                    selected: 'SELECT',
                    buttons: [
                        { id: 'SELECT', label: 'gb_consignmentplanbuild_add_select', color: 'primary', onClick: () => vm.model.bgConsignmentPlanBuildAdd.selected = 'SELECT' },
                        { id: 'VIEWORDER', label: 'gb_consignmentplanbuild_add_vieworder', color: 'primary', onClick: () => vm.model.bgConsignmentPlanBuildAdd.selected = 'VIEWORDER' }
                    ]
                },
                setting: {},
                selectListStockPlaces: [],
                selectListDeliveryMethods: [],
                selectListTransportAreas: [],
                itemsListBuilds: [],
                itemsListBuildOns: [],
                itemsListSplits: [],
                retrieving: false,
                lockedSave: false,
                lockedRemove: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE CALLS

            async function loadSetting() {
                vm.model.setting = (await consignmentPlanBuildService.getSetting({ custact_no: custactNo }))[0];

                Promise.all([
                    loadTransportAreas()
                ]).then(() => {
                    loadBuilds();
                    loadBuildOns();
                    Promise.resolve();
                });
            }

            async function loadStockPlaces() {
                vm.model.selectListStockPlaces = await consignmentPlanService.listStockPlaces();
            }

            async function loadDeliveryMethods() {
                vm.model.selectListDeliveryMethods = await colliDispatchService.listDeliveryMethods({ add_all: '1' });
            }

            async function loadTransportAreas() {
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

                vm.model.selectListTransportAreas = await transportAreasService.listAreas({
                    add_all: '1',
                    stockplace_id: vm.model.setting.stockplace_id
                });
            }

            async function loadBuildOns() {
                if (utilityService.validateParmsValue(vm.model.setting.custact_no) !== true) return;

                vm.model.itemsListBuildOns = await consignmentPlanBuildService.listBuildOns({ custact_no_consignmentplan: vm.model.setting.custact_no });
            }

            function delaySpinStop() {
                if (spinStopTimer) clearTimeout(spinStopTimer);

                spinStopTimer = setTimeout(() => vm.model.retrieving = false, 100);
            }

            async function loadBuilds() {
                if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) {
                    delaySpinStop();
                    return;
                }

                if (utilityService.validateParmsValue(vm.model.setting.date_tom) !== true) {
                    delaySpinStop();
                    return;
                }

                if (utilityService.validateParmsValue(vm.model.setting.dateselector_index) !== true) {
                    delaySpinStop();
                    return;
                }

                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) {
                    delaySpinStop();
                    return;
                }

                if (utilityService.validateParmsValue(vm.model.setting.deliverymethod_no) !== true) {
                    delaySpinStop();
                    return;
                }

                if (utilityService.validateParmsValue(vm.model.setting.transportarea_keyno) !== true) {
                    delaySpinStop();
                    return;
                }

                if (utilityService.validateParmsValue(vm.model.setting.filtervalue, true) !== true) {
                    delaySpinStop();
                    return;
                }

                vm.model.itemsListBuilds = [];

                return consignmentPlanBuildService.listBuilds(vm.model.setting).then((list) => {
                    vm.model.retrieving = false;
                    vm.model.itemsListBuilds = list;
                });
            };

            async function loadSplits() {
                vm.model.itemsListSplits = await consignmentPlanBuildService.listSplits(vm.model.setting);
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'date_fom':
                    case 'date_tom':
                    case 'dateselector_index':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // ## REFRESH BUTTON FUNCTION ##

            vm.retrieve = function () {
                vm.model.retrieving = true;
                loadBuilds();
            };

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgConsignmentPlanBuildFunction = function (value) {
                vm.model.bgConsignmentPlanBuildFunction.selected = value;

                if (vm.model.bgConsignmentPlanBuildFunction.selected === 'SPLIT') loadSplits();
            };

            vm.selectBgConsignmentPlanBuildAdd = function (value) {
                vm.model.bgConsignmentPlanBuildAdd.selected = value;
            };

            // #endregion BUTTON RADIO FUNCTIONS

            // ## BUTTON LIST FUNCTIONS ##

            function clearDeliveryMethod() {
                vm.model.setting.deliverymethod_no = '0';
                onFieldChanged();
            }

            function clearTransportArea() {
                vm.model.setting.transportarea_keyno = '0';
                onFieldChanged();
            }

            // ## TOGGLE FUNCTIONS ##

            vm.toggleChosenBuild = function (item) {
                if (item.item_id === '0') return;
                if (item.item_id === '-1') return;

                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                }
            };

            vm.toggleChosenBuildOn = function (item) {
                if (item.item_id === '0') return;
                if (item.item_id === '-1') return;

                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                }
            };

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                consignmentPlanBuildService.saveObj({
                    custact_no_consignmentplan: vm.model.setting.custact_no,
                    records: vm.model.itemsListBuilds
                }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                        vm.model.lockedSave = false;

                        loadBuilds();
                        loadBuildOns();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.removeSelected = function () {
                vm.model.lockedRemove = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_remove_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    consignmentPlanBuildService.removeItems({
                        custact_no_consignmentplan: vm.model.setting.custact_no,
                        records: vm.model.itemsListBuildOns
                    }).then((response) => {
                        if (response[0] && response[0].errorcode !== '0') {
                        	modalService.show({
                        		type: 'warning',
                        		title: translations.error,
                        		message: response[0].errormessage,
                        		buttons: [{
                        			label: translations.ok,
                        			cssClass: 'btn-warning',
                        			action: function (dialogItself) {
                        				dialogItself.close();
                        				vm.model.lockedRemove = false;
                        			}
                        		}]
                        	});
                        } else {
                            vm.model.lockedRemove = false;

                            loadBuilds();
                            loadBuildOns();
                        }
                    }, () => {
                        vm.model.lockedRemove = false;
                    });
                }, () => {
                    vm.model.lockedRemove = false;
                });
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            function onFieldChanged() {
                vm.retrieve();

                if (vm.model.bgConsignmentPlanBuildFunction.selected === 'SPLIT') {
                    loadSplits();
                }
            }

            vm.onStockPlaceChanged = function (value) {
                vm.model.setting.stockplace_id = value;

                if (value) {
                    loadTransportAreas();
                    onFieldChanged();
                }
            }

            vm.onDeliveryMethodChanged = function (value) {
                vm.model.setting.deliverymethod_no = value;

                if (value) {
                    onFieldChanged();
                }
            }

            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
                vm.model.setting.date_fom = startDate;
                vm.model.setting.date_tom = endDate;
                if (dateInterval !== -1) vm.model.setting.dateselector_index = dateInterval;

                if (vm.model.setting.date_fom) rememberFunc('date_fom');
                if (vm.model.setting.date_tom) rememberFunc('date_tom');
                if (vm.model.setting.dateselector_index) rememberFunc('dateselector_index');

                if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) {
                    vm.retrieve();

                    if (vm.model.bgConsignmentPlanBuildFunction.selected === 'SPLIT') {
                        loadSplits();
                    }
                }
            }

            vm.onTransportAreaChanged = function (value) {
                vm.model.setting.transportarea_keyno = value;

                if (value) {
                    onFieldChanged();
                }
            }

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadSetting();
                loadStockPlaces();
                loadDeliveryMethods();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
